export enum RoutePolicy {
  ForAnyone = "FOR_ANYONE",
  ForGuests = "FOR_GUESTS",
  ForAuthenticated = "FOR_AUTHENTICATED",
}
